import classNames from 'classnames';
import {ReactNode} from 'react';

export const Table = ({
  head,
  body,
  isFixedTableLayout = false
}: {
  head: ReactNode;
  body: ReactNode;
  isFixedTableLayout?: boolean;
}) => {
  return (
    <table className={classNames('relative overflow-auto border-separate', {'w-full table-fixed': isFixedTableLayout})}>
      <thead className="sticky top-0 z-10">{head}</thead>
      <tbody>{body}</tbody>
    </table>
  );
};
